// extracted by mini-css-extract-plugin
module.exports = {"item":"ApplicationMenuItem_item__OYpMm","itemActive":"ApplicationMenuItem_itemActive__F2Q_l"};